import { render, staticRenderFns } from "./contact-export.vue?vue&type=template&id=a906d6b6&scoped=true"
import script from "./contact-export.vue?vue&type=script&lang=ts"
export * from "./contact-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a906d6b6",
  null
  
)

export default component.exports